import React, { useEffect, useState } from "react";
import Commongrid from "../../common/Commongrid";
import formatDateAndTime from "../../common/formatDateAndTime";
import { useNavigate } from "react-router-dom";

function createData(
  id,
  serviceCode,
  serviceType,
  serviceStatus,
  isPaymentPending,
  odometerReading,
  endingOdometer,
  createdAt,
) {
  return {
    id,
    serviceCode,
    serviceType,
    serviceStatus,
    isPaymentPending,
    odometerReading,
    endingOdometer,
    createdAt,
  };
}

const Myworkorders = ({ selectedRow }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const workorderType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.workorderType;
  delete workorderType?.inverted;
  const workorderStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.workorderStatus;  
  const navigate = useNavigate();
  const [totalCount, setTotalCount] = useState(0);
  const [myworkOrders, setMyWorkOrderDetails] = useState([]);
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 20,
  });
  const [loading, setLoading] = useState(false);
  const [vehicleId, setVehicleId] = useState(null);

  const columns = [
    {
      field: "id",
      headerName: "Id",
      minWidth: 100,
      align: "start",
      sortable: false,
    },
    {
      field: "serviceCode",
      headerName: "Service Code",
      minWidth: 250,
      align: "start",
      sortable: false,
    },
    {
      field: "serviceType",
      headerName: "Service Type",
      minWidth: 200,
      align: "start",
      sortable: false,
    },
    {
      field: "serviceStatus",
      headerName: "Service Status",
      minWidth: 150,
      align: "start",
    },
    {
      field: "isPaymentPending",
      headerName: "Payment Pending",
      minWidth: 190,
      align: "start",
    },
    {
      field: "odometerReading",
      headerName: "Odometer Reading",
      minWidth: 150,
      align: "start",
      sortable: false,
    },
    {
      field: "endingOdometer",
      headerName: "Ending Odometer",
      minWidth: 150,
      align: "start",
    },
    {
      field: "createdAt",
      headerName: "Created At",
      minWidth: 200,
      align: "start",
    },
  ];

  const rows =
    (myworkOrders &&
      myworkOrders?.map((item) =>
        createData(
          item?.id,
          item?.serviceCode,
          workorderType[item?.serviceType],
          workorderStatus[item?.serviceStatus],
          item?.isPaymentPending,
          item?.odometerReading + " Kms",
          item?.endingOdometer + " Kms",
          formatDateAndTime(item?.createdAt),          
        ),
      )) ||
    [];

  const getVehicleIssues = async (page = 0, pageSize = 20) => {
    const limit = pageSize;
    const offset = page * pageSize;

    try {
      setLoading(true);

      const response = await fetch(
        `${apiUrl}/api/vehicleservices?limit=${limit}&offset=${offset}&vehicleId=${vehicleId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        setMyWorkOrderDetails(data?.entities?.rows || []);
        setTotalCount(data?.entities?.count || 0);
      }

      return data;
    } catch (error) {
      console.error("Error fetching NRK listings:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (vehicleId) {
      getVehicleIssues(paginationModel.page, paginationModel.pageSize);
    }
  }, [vehicleId, paginationModel]);

  useEffect(() => {
    if (selectedRow) {
      setVehicleId(selectedRow.id);
    }
  }, [selectedRow]);

  return (
    <>
      <Commongrid
        rows={rows}
        columns={columns}
        totalCount={totalCount} // total rows from API
        handleViewClick={(params) => {
          const navigate = `/workorder?serviceId=${params?.id}&display=true`;
          window.open(navigate, "_blank");
        }}
        api={getVehicleIssues}
        setPaginationModel={setPaginationModel}
        paginationModel={paginationModel}
        loading={loading}
        disableColumnMenu={false}
      />
    </>
  );
};

export default Myworkorders;
